import { ApiProperty } from "@nestjs/swagger";

export class DateDeptRequest{
    @ApiProperty()
    date : Date;
    @ApiProperty()
    deptName : string;
}

export class DeptDateHourRequest{
    @ApiProperty()
    date: string;
    @ApiProperty()
	hour: number;
    @ApiProperty()
	minutes?: number;
    @ApiProperty()
	deptCode: string;
    @ApiProperty()
    uid:string;
}

export class DayWiseTempRequest{
    @ApiProperty()
    deptCode: string;
    @ApiProperty()
	month?: number;
    @ApiProperty()
	startDate?: string;
    @ApiProperty()
	endDate?: string;
    @ApiProperty()
    uid:string;
}

export class UidRequest{
    @ApiProperty()
    uid:string;
}